import { useState } from "react";
import styles from "../styles/FinanceView.module.css";

import CardWalletsTable from "../pages/FinanceView/CardWalletsTable";
import CashWalletsTable from "../pages/FinanceView/CashWalletsTable";

const tabs = [
  { key: "card", label: "Банк" },
  { key: "cash", label: "Кассы" },
];

const FinanceView = () => {
  const [tab, setTab] = useState("card");

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Финансы</h2>

      <div className={styles.tabs}>
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`${styles.tab} ${tab === t.key ? styles.activeTab : ""}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className={styles.card}>
        {tab === "card" ? <CardWalletsTable /> : <CashWalletsTable />}
      </div>
    </div>
  );
};

export default FinanceView;
